import { Seo } from "../components/Seo";

import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Welcome to Laura Combs Productions.");
      navigate("/account", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <Seo title="Create Account" description="Create your Laura Combs Productions account." path="/register" noindex />
      <div className="text-center mb-10">
        <span className="text-gold text-sm uppercase tracking-[0.3em]">Begin your journey</span>
        <h1 className="font-serif text-5xl text-forest mt-3">Create Account</h1>
      </div>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-gold/30 shadow-sm p-8 space-y-5">
        <div>
          <Label htmlFor="name" className="text-charcoal">Name</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required
            className="mt-2 rounded-xl border-gold/40 focus-visible:ring-gold" data-testid="register-name" />
        </div>
        <div>
          <Label htmlFor="email" className="text-charcoal">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="mt-2 rounded-xl border-gold/40 focus-visible:ring-gold" data-testid="register-email" />
        </div>
        <div>
          <Label htmlFor="password" className="text-charcoal">Password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="mt-2 rounded-xl border-gold/40 focus-visible:ring-gold" data-testid="register-password" />
          <p className="text-charcoal/40 text-xs mt-1">At least 6 characters.</p>
        </div>
        {error && <p className="text-destructive text-sm" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading}
          className="w-full rounded-full bg-forest hover:bg-forest-light text-ivory h-12 transition-colors" data-testid="register-submit">
          {loading ? "Creating…" : "Create Account"}
        </Button>
      </form>
      <p className="text-center text-charcoal/60 text-sm mt-6">
        Already have an account?{" "}
        <Link to="/login" className="text-forest hover:text-gold underline underline-offset-4">Sign in</Link>
      </p>
    </div>
  );
}
